/* eslint-disable react/jsx-no-bind */
// AccordionTopic displays related article list in the HCR topic page
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Scroll from 'react-scroll';

import { Accordion, AccordionRow, Link } from '@paypalcorp/pp-react';
import { updateBreadcrumb } from '../actions/action-breadcrumb';
import { TOPIC } from '../constants/PropTypesShapes';
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';
import { trackLink } from '../../lib/analytics-helper';

import {
  updateSelectedL3SubTopic,
  updateSelectedL3SubTopicDetails,
  updateSelectedSubTopicDetails,
} from '../actions/action-L3Topic-list';
import getHistory from '../../lib/HistoryHelper';
import {
  ECM_DOC_ID_KEY,
  ECM_COMPONENT_IDS_KEY,
  ECM_DOC_ID_DEFAULT_VALUE,
  ECM_COMPONENT_IDS_DEFAULT_VALUE,
} from '../../contactUs/constants/ecmFPTITagsKeys';

const exp = Page.getUserExperience();
const title = i18n.message(`smarthelp/contentToggle.content.label.desktop.${exp}`);
const home = `/${exp}/home`;
const topicPath = `/${exp}/topic`;

// Scroll
const scroll = Scroll.animateScroll;

const accordionFAQlimit = 10;
const showMoreText = i18n.message('smarthelp/contentToggle.content.showMore');

class AccordionTopic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowMore: false,
    };
    this.toggle = this.toggle.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleShowMoreClick = this.handleShowMoreClick.bind(this);
  }

  static renderTopicList(topicsList, topic = {}) {
    if (topic.name) {
      const topicDescription = i18n.message('smarthelp/contentToggle.content.topicLabel', { topicName: topic.name });
      return (
        <div>
          <span>{topicDescription}</span>
          {topicsList}
        </div>
      );
    }
    return <div />;
  }

  // Handle Key press for accessing the subTopics in the L2 topics
  handleKeyPress(event) {
    if (event.which === 13) {
      this.toggle();
    }
  }

  // Handle Key Press for click articles in the topics list
  handleArticleKeyPress(event, article, parentTopics, subTopics, articleList) {
    if (event.which === 13) {
      this.goToArticle(article, parentTopics, subTopics, articleList);
    }
  }

  // Handle Key Press for click l2 topics
  handleTopicKeyPress(event, parent, topic, subTopic) {
    if (event.which === 13) {
      this.updateTopicBreadCrumb(parent, topic, subTopic);
    }
  }

  handleShowMoreClick(value) {
    this.setState({
      isShowMore: value,
    });
    const { parent, topic, isL3TopicClicked } = this.props;

    const fptiParentId = (parent && parent.id) || '';
    const fptiTopicId = (topic && topic.id) || '';

    if (isL3TopicClicked) {
      trackLink({
        id: 'L3topicArticleShowMoreClicked',
        link: `smarthelp-article-page|${exp}|${fptiParentId}|${fptiTopicId}|showMoreExpanded`,
      });
    } else {
      trackLink({
        id: 'L2topicArticleShowMoreClicked',
        link: `smarthelp-article-page|${exp}|${fptiParentId}|${fptiTopicId}|showMoreExpanded`,
      });
    }
  }

  // To determine show/hide the faq.
  getCorrespondingClassShowMore(index, length) {
    if (!this.state.isShowMore) {
      if (length > accordionFAQlimit && index >= accordionFAQlimit) {
        return 'item-display-none';
      }
    }
    return '';
  }

  // L2 topic tree transition animation
  scollTopicToTop() {
    if (this.accodionContainer) {
      setTimeout(() => {
        const $topDistance =
          this.accodionContainer.getBoundingClientRect && this.accodionContainer.getBoundingClientRect().top;
        const options = {
          duration: 500,
          smooth: true,
        };
        if ($topDistance < 0) {
          scroll.scrollMore($topDistance - 100, options);
        }
      }, 400);
    }
  }

  toggle() {
    const topic = this.props.topic;
    const expanded = !this.props.expanded;
    this.props.onToggle(topic, expanded);
    const accordianState = expanded ? 'expanded' : 'collapsed';
    if (this.props.isL3TopicClicked) {
      trackLink({
        id: 'L3TopicAccordionClicked',
        link: `smarthelp-subtopic-expanded-collapsed|${topic && topic.id}|${accordianState}`,
      });
    } else {
      trackLink({
        id: 'L2TopicAccordionClicked',
        link: `smarthelp-subtopic-expanded-collapsed|${topic && topic.id}|${accordianState}`,
      });
    }
    this.scollTopicToTop();
  }

  // Function to Update bread crumb when clicked on article
  goToArticle(article, parentTopics, subTopics, articleList) {
    if (window.localStorage) {
      window.localStorage.setItem('isHome', true);
    }
    const { isL3TopicClicked } = this.props;
    const items = [];

    // default values for the fpti tags
    let fptiFaqId = '';
    let fptiDocId = ECM_DOC_ID_DEFAULT_VALUE;
    let fptiComponentIds = ECM_COMPONENT_IDS_DEFAULT_VALUE;

    // provide the valid fpti tags when article data exists
    if (article) {
      fptiFaqId = article.articleId;
      fptiDocId = article[ECM_DOC_ID_KEY] || ECM_DOC_ID_DEFAULT_VALUE;
      fptiComponentIds = article[ECM_COMPONENT_IDS_KEY] || ECM_COMPONENT_IDS_DEFAULT_VALUE;
    }

    // when clicked on article under L2 Topic
    if (!Page.isMobileLayout()) {
      items.push(
        {
          title,
          path: home,
          id: parentTopics.id,
        },
        {
          title: parentTopics.articleTitle,
          path: `${topicPath}/${parentTopics.id}`,
          id: parentTopics.id,
        },
        {
          title: subTopics.name,
          path: `${topicPath}/${parentTopics.id}`,
          id: subTopics.id,
        },
      );
    } else {
      items.push({
        title: subTopics.name,
        path: `${topicPath}/${parentTopics.id}`,
        id: subTopics.id,
      });
    }

    // when clicked on article under L3 Topic
    if (articleList && isL3TopicClicked) {
      const articleBreadCrumbs = [];
      const { SelectedL1TopicDetails } = this.props;
      const L1TopicId = SelectedL1TopicDetails.topicId;

      if (!Page.isMobileLayout()) {
        articleBreadCrumbs.push(
          {
            title,
            path: '/home',
            id: parentTopics.id,
          },
          {
            title: SelectedL1TopicDetails.topicName,
            path: `/topic/${L1TopicId}`,
            id: parentTopics.id,
          },
          {
            title: parentTopics.articleTitle,
            path: `/topic/${L1TopicId}/${parentTopics.id}`,
            id: articleList.id,
          },
        );
      } else {
        articleBreadCrumbs.push({
          title: parentTopics.articleTitle,
          path: `/topic/${L1TopicId}/${parentTopics.id}`,
          id: articleList.id,
        });
      }

      trackLink({
        id: 'L3topicArticleClicked',
        link: `smarthelp-article-page|${exp}|${fptiFaqId}`,
        hpid: fptiFaqId,
        help_doc_id: fptiDocId,
        help_component_ids: fptiComponentIds,
      });
      this.props.updateSelectedL3SubTopicDetails(articleList, article, articleBreadCrumbs);
    }
    if (!isL3TopicClicked) {
      trackLink({
        id: 'L2topicArticleClicked',
        link: `smarthelp-article-page|${exp}|${fptiFaqId}`,
        hpid: fptiFaqId,
        help_doc_id: fptiDocId,
        help_component_ids: fptiComponentIds,
      });
      this.props.updateBreadcrumb(items);
    }
  }

  // Function to update breadcrumb when clicked on L3 Topic
  updateTopicBreadCrumb(parentTopics, topic, subTopic) {
    const items = [];
    const { SelectedL1TopicDetails } = this.props;
    const parentTopicId = parentTopics.id || SelectedL1TopicDetails.topicId;
    if (!Page.isMobileLayout()) {
      items.push(
        {
          title,
          path: home,
          id: parentTopicId,
        },
        {
          title: parentTopics.articleTitle,
          path: `${topicPath}/${parentTopicId}`,
          id: parentTopicId,
        },
        {
          title: topic.name,
          path: `${topicPath}/${parentTopicId}/${topic.id}`,
          id: topic.id,
        },
      );
    } else {
      items.push({
        title: topic.name,
        path: `${topicPath}/${parentTopicId}/${topic.id}`,
        id: topic.id,
      });
    }
    trackLink({ id: 'L3topicClicked', link: `smarthelp-hcr-topic-list|${topic.id}|${subTopic.subTopicId}` });
    this.props.updateBreadcrumb(items);
    this.props.updateSelectedSubTopicDetails(topic);
    this.props.updateSelectedL3SubTopic(subTopic);
    getHistory().push(`/topic/${parentTopicId}/${topic.id}`);
  }

  // to Render showMore button
  renderShowMoreButton(articleList = {}) {
    // If the state value isShowMore is true hide the show more button
    if (this.state.isShowMore) {
      return null;
    }

    // If any of these validation is true, display show more button
    if (
      (Array.isArray(articleList.faqList) && articleList.faqList.length >= accordionFAQlimit) ||
      (Array.isArray(articleList.subTopicList) && articleList.subTopicList.length >= accordionFAQlimit)
    ) {
      return (
        <Link theme="v2" onClick={() => this.handleShowMoreClick(true)}>
          {showMoreText}
        </Link>
      );
    }

    // If none of the conditions are met, do not display show more button
    return null;
  }

  renderAccordionContent(articleList = {}, parentTopics) {
    const subTopics = {
      id: articleList.id,
      name: articleList.name,
    };

    let listItems;
    // For topics with articles at second level
    const articles = articleList.faqList;
    if (Array.isArray(articles) && articles.length) {
      listItems = articles.map((article, index) => (
        <div key={article.articleId} className={`${this.getCorrespondingClassShowMore(index, articles.length)}`}>
          <Link
            href={Page.getFullArticleURL(article)}
            onClick={() => this.goToArticle(article, parentTopics, subTopics, articleList)}
            onKeyPress={(event) => this.handleArticleKeyPress(event, article, parentTopics, subTopics, articleList)}
            primaryAlt
            theme="v2"
          >
            {article.articleTitle}
          </Link>
        </div>
      ));
    }

    // For L3 topics
    if (Array.isArray(articleList.subTopicList) && articleList.subTopicList.length) {
      const { parent, topic } = this.props;
      const topicsList = articleList.subTopicList.map((subTopic, index) => (
        <div
          key={subTopic.subTopicId}
          className={`${this.getCorrespondingClassShowMore(index, articleList.subTopicList.length)}`}
        >
          <Link
            href="#"
            onClick={() => this.updateTopicBreadCrumb(parent, topic, subTopic)}
            onKeyPress={(event) => this.handleTopicKeyPress(event, parent, topic, subTopic)}
            primaryAlt
            theme="v2"
          >
            {subTopic.subTopicName}
          </Link>
        </div>
      ));

      listItems = AccordionTopic.renderTopicList(topicsList, topic);
    }

    return <ul className="accordion-topic-list">{listItems}</ul>;
  }

  render() {
    const { topic, parent, selectedL3TopicDetails } = this.props;
    return (
      <div
        ref={(click) => {
          this.accodionContainer = click;
        }}
      >
        <Accordion name="accordionTopic" theme="v2">
          <AccordionRow
            heading={topic.name}
            isOpen={
              selectedL3TopicDetails &&
              selectedL3TopicDetails.subTopicId &&
              topic.id === selectedL3TopicDetails.subTopicId
            }
          >
            {this.renderAccordionContent(topic, parent)}
            {this.renderShowMoreButton(topic)}
          </AccordionRow>
        </Accordion>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateBreadcrumb,
      updateSelectedSubTopicDetails,
      updateSelectedL3SubTopicDetails,
      updateSelectedL3SubTopic,
    },
    dispatch,
  );
}

function mapStateToProps(state) {
  return {
    selectedL3TopicDetails: state.L3TopicList.SelectedL3TopicDetails,
  };
}

AccordionTopic.propTypes = {
  expanded: PropTypes.bool.isRequired,
  topic: PropTypes.shape(TOPIC).isRequired,
  onToggle: PropTypes.func.isRequired,
  updateBreadcrumb: PropTypes.func.isRequired,
  parent: PropTypes.shape({
    id: PropTypes.string,
    articleTitle: PropTypes.string,
  }).isRequired,
  updateSelectedL3SubTopicDetails: PropTypes.func.isRequired,
  updateSelectedL3SubTopic: PropTypes.func.isRequired,
  updateSelectedSubTopicDetails: PropTypes.func.isRequired,
  isL3TopicClicked: PropTypes.bool.isRequired,
  SelectedL1TopicDetails: PropTypes.shape(TOPIC).isRequired,
  selectedL3TopicDetails: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(AccordionTopic);
